export const clone_page_atom_service_to_theme_atom_service = {
  error_unknown: 'Something is wrong, an unexpected error has occurred.',
  clone_error: 'Clone failed',
  clone_success: 'Clone successful',
  cloning: 'Cloning',
  init_clone: 'Initiating process',
  init_clone_error: 'Initialization failed',
} as const;
